<template>
  <div class="flex items-center gap-4px rounded-full bg-light-gray py-8px pl-16px pr-8px">
    <p class="content-12-h16-r text-primary-50">{{ chipData.title }}</p>
    <i class="icon-close cursor-pointer text-16px text-primary-100" @click="$emit('remove')" />
  </div>
</template>

<script setup lang="ts">
import { type ChipData } from '@/components/TagChip.type'

defineProps<{
  chipData: ChipData
}>()

defineEmits<{
  remove: []
}>()
</script>
